enum Status {
  COMPLETED = 'completed',
  ON_GOING = 'on_going',
  ON_PROCESSING = 'on_processing',
  PENDING = 'pending',
  PROCESSING_FAILED = 'processing_failed',
  SCHEDULE_READY = 'schedule_ready',
  SCHEDULE_START_FAILED = 'schedule_start_failed',
  SCHEDULE_CANCELED = 'schedule_canceled',
}

export default Status;
